var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16MenuPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M8.967 4H12.5c.828 0 1.5.672 1.5 1.5v7c0 .828-.672 1.5-1.5 1.5h-11C.672 14 0 13.328 0 12.5V8.1h0",
    transform: "translate(-448 -49) translate(448 49) translate(1 1) matrix(-1 0 0 1 14 0)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.412 9.794L6.412 9.794M2.412 11.794L4.412 11.794",
    transform: "translate(-448 -49) translate(448 49) translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-448 -49) translate(448 49) translate(1 1) translate(6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M4.226 6.672V6.09c.363-.037.648-.159.855-.366.207-.207.31-.477.31-.809 0-.177-.027-.333-.081-.467-.055-.134-.134-.253-.238-.357-.103-.105-.23-.198-.38-.282-.151-.083-.343-.17-.576-.265-.234-.093-.393-.185-.48-.275-.085-.09-.128-.209-.128-.357 0-.16.044-.286.132-.377.088-.09.212-.136.372-.136.162 0 .291.058.388.174.097.116.145.292.145.526h.847c0-.38-.098-.69-.293-.93-.196-.24-.466-.383-.812-.432V1.1h-.469v.627c-.35.035-.63.158-.84.37-.211.21-.317.48-.317.81 0 .192.03.357.092.496.062.138.148.259.258.362.11.102.243.193.397.272.155.08.338.159.551.239.213.08.364.167.453.262.088.095.133.222.133.382 0 .155-.05.277-.15.368-.1.09-.235.136-.407.136-.207 0-.365-.062-.476-.186-.11-.124-.165-.302-.165-.534H2.5c0 .4.11.72.33.962.22.241.53.383.93.426v.58h.466z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16MenuPay);
export default __webpack_public_path__ + "static/media/ico16MenuPay.602d6732.svg";
export { ForwardRef as ReactComponent };